import { formatInTz, startOfWeekInTz, endOfWeekInTz, subDays, formatDateInputInTz, nowInTimezone } from './timezone';

export interface WeekOption {
  value: string;
  label: string;
  startDate: string;
  endDate: string;
}

/**
 * Generate a list of week options for selection.
 * Returns 2 future weeks + current week + 8 past weeks (11 total).
 */
export const generateWeekOptions = (timezone: string): WeekOption[] => {
  const weeks: WeekOption[] = [];
  const now = nowInTimezone(timezone);
  
  // Generate weeks: -2 (future) to +8 (past)
  for (let i = -2; i <= 8; i++) {
    const referenceDate = subDays(now, i * 7);
    const weekStart = startOfWeekInTz(referenceDate, timezone);
    const weekEnd = endOfWeekInTz(referenceDate, timezone);
    
    const startStr = formatDateInputInTz(weekStart, timezone);
    const endStr = formatDateInputInTz(weekEnd, timezone);
    
    let label: string;
    if (i === 0) {
      label = `This Week: ${formatInTz(weekStart, timezone, 'MMM d')} - ${formatInTz(weekEnd, timezone, 'MMM d')}`;
    } else if (i === 1) {
      label = `Last Week: ${formatInTz(weekStart, timezone, 'MMM d')} - ${formatInTz(weekEnd, timezone, 'MMM d')}`;
    } else if (i === -1) {
      label = `Next Week: ${formatInTz(weekStart, timezone, 'MMM d')} - ${formatInTz(weekEnd, timezone, 'MMM d')}`;
    } else if (i < 0) {
      label = `${formatInTz(weekStart, timezone, 'MMM d')} - ${formatInTz(weekEnd, timezone, 'MMM d')} (${Math.abs(i)} weeks ahead)`;
    } else {
      label = `${formatInTz(weekStart, timezone, 'MMM d')} - ${formatInTz(weekEnd, timezone, 'MMM d')} (${i} weeks ago)`;
    }
    
    weeks.push({
      value: startStr,
      label,
      startDate: startStr,
      endDate: endStr,
    });
  }
  
  return weeks;
};
